import Skeleton from 'react-loading-skeleton';

interface WalletSkeletonProps {
  width?: number | string;
  height?: number;
  className?: string;
}

export default function WalletSkeleton({
  width = 70,
  height = 18,
  className = '',
}: Readonly<WalletSkeletonProps>) {
  return (
    <Skeleton
      width={width}
      height={height}
      borderRadius={6}
      duration={1.2}
      containerClassName={`wallet-skeleton ${className}`.trim()}
    />
  );
}
